import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { createPageData, sparePartRequestFormData } from "./ScrapFile.js";
import BasicPopupModel from "../../custom_components/Components/BasicPopupModel.js";

import { AvForm } from "availity-reactstrap-validation";
import {
  formatDate,
  getRecords,
  saveRecords,
} from "../../services/api.service.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../Style/loaderOverly.js";
import { LoaderCreatePage } from "../Loader/Loader.js";
import formatDateTime from "../../custom/Utils/formatDateTime.js";
import { toast } from "react-toastify";
import TextAreaInput from "../../custom/components/TextArea-Input/TextAreaInput.js";
import { validate } from "../../custom/validations/Validate.js";

const ScrapView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, validationType, getEndpoint, createEndpoint } =
    createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(sparePartRequestFormData());
  const [fetchedData, setFetchedData] = useState(null);
  const [remark, setRemark] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [popup, setPopup] = useState(false);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  const getEditData = async (id) => {
    const schema = localStorage.getItem("schema");

    try {
      const payload = {
        modelName: "scraps",
        schema: schema,

        include: [
          {
            model: "material_intakes",
            as: "intake",
            include: [{ model: "material_masters", as: "material" }],
          },
          {
            model: "scrap_reason_masters",
            as: "reason",
          },
          {
            model: "user_masters",
            as: "approved_by_user",
          },
          {
            model: "job_cards",
            as: "job_cards",
          },
        ],
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFormData({ inputData: data });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };
  const onInputChange = (e) => {
    const { name, value } = e.target;

    // update form data
    setFormData((prev) => ({
      ...prev,
      inputData: {
        ...prev.inputData,
        [name]: value,
      },
    }));

    // handle error ONLY for remark
    if (name === "remark") {
      setFormErrors((prev) => ({
        ...prev,
        remark: value.trim() === "" ? "Remark cannot be blank." : "",
      }));
    }
  };

  const handleApproveClick = () => {
    const remark = formData?.inputData?.remark?.trim();

    if (!remark) {
      setFormErrors((prev) => ({
        ...prev,
        remark: "Remark cannot be blank.",
      }));
      return;
    }

    // clear remark error if valid
    setFormErrors((prev) => ({
      ...prev,
      remark: "",
    }));

    setPopup(true);
  };

  const handleApproveScrap = async () => {
    try {
      setLoadingData(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));

      // let validationErrors = validate(validationType, formData.inputData);

      // if (!formData?.inputData?.job_card_no) {
      //   delete validationErrors["job_card_no"];
      // }
      // setFormErrors(validationErrors);
      // if (JSON.stringify(validationErrors) !== "{}") return;
      // Additional validation for `user_documents`

      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
      };

      if (id) {
        // update
        formData.inputData.updated_by = id ? userDetails?.id || "" : "";
        formData.inputData.status = "Scrapped";
        payload = { ...payload, id: id, inputData: formData.inputData };
      } else {
        // create
        formData.inputData.created_by = userDetails?.id || "";
        formData.inputData.updated_by = userDetails?.id || "";
        payload = { ...payload, inputData: formData.inputData };
      }

      payload.inputData = {
        ...payload.inputData,
      };

      console.log("payload", payload);
      const responseData = await saveRecords(payload, createEndpoint);

      // Handle response
      if (responseData && responseData.code === 1) {
        toast.success(`Item scrapped successfully!`);
        navigate(navigatePage?.back);
      } else {
        toast.error(responseData.message || `Error`);
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Scrap Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Scrap No: </strong>
                                {formData?.inputData?.scrap_no || "-"}
                              </p>
                              <p>
                                <strong>Intake: </strong>
                                {formData?.inputData?.intake?.intake_no || "-"}
                              </p>
                              <p>
                                <strong>Item Name: </strong>
                                {formData?.inputData?.intake?.material?.name ||
                                  "-"}
                              </p>

                              <p>
                                <strong>Job Card: </strong>
                                {formData?.inputData?.job_card?.job_card_no ||
                                  "-"}
                              </p>

                              <p>
                                <strong>Scrap Reason: </strong>
                                {formData?.inputData?.scrap_reason_id == 0
                                  ? formData?.inputData?.job_cards
                                      ?.technician_custom_reason
                                  : formData?.inputData?.reason?.reason || "-"}
                              </p>
                            </Col>

                            {/* Second Section (Right Side) */}

                            <Col md="6" className="p-3">
                              <p>
                                <strong>Scrap Status: </strong>
                                {formData?.inputData?.status || "-"}
                              </p>
                              <p>
                                <strong>Is Active: </strong>
                                {formData?.inputData?.is_active === true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>

                              <p>
                                <strong>Created At: </strong>
                                {!formData?.inputData?.createdAt || loadingData
                                  ? "-"
                                  : formatDateTime(
                                      formData?.inputData?.createdAt
                                    )}
                              </p>

                              <p>
                                <strong>Updated At: </strong>
                                {!formData?.inputData?.updatedAt || loadingData
                                  ? "-"
                                  : formatDateTime(
                                      formData?.inputData?.updatedAt
                                    )}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>
                      {formData.inputData.status == "Pending Approval" && (
                        <>
                          <Row className="mt-3">
                            <Col md="4">
                              <TextAreaInput
                                label="Remark"
                                name="remark"
                                value={formData?.inputData?.remark}
                                onChange={onInputChange}
                                parentClassName=""
                                inputClassName="form-control"
                                labelClassName="form-label"
                                placeholder="Remark"
                                asterisk={true}
                                customError={formErrors?.remark}
                              />
                            </Col>
                          </Row>

                          <div className="d-flex justify-content-center flex-grow-1">
                            <Button
                              color="primary"
                              style={{ height: "40px" }}
                              className="waves-effect waves-light me-1 back-button ml-2"
                              onClick={handleApproveClick}
                            >
                              Approve Scrap
                            </Button>
                            <Button
                              color="secondary"
                              style={{ height: "40px" }}
                              className="waves-effect waves-light me-1 back-button ml-2"
                              onClick={() => navigate(navigatePage?.back)}
                            >
                              Cancel
                            </Button>
                          </div>
                        </>
                      )}
                    </AvForm>
                    <BasicPopupModel
                      isVisible={popup}
                      onClose={() => setPopup(false)}
                      title={"Are you sure you want to mark this as scrapped?"}
                    >
                      <div className="mt-3">
                        <div className="text-center">
                          <span>Scrap No: </span>{" "}
                          <strong>{formData?.inputData?.scrap_no}</strong>
                        </div>
                        <div className="mt-3 d-flex gap-3 flex-wrap justify-content-center">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              handleApproveScrap();
                              setPopup(false);
                            }}
                          >
                            Approve Scrap{" "}
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setPopup(false);
                            }}
                            className="btn btn-secondary"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </BasicPopupModel>
                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ScrapView;
